'use client';

import { useShallow } from 'zustand/shallow';
import { usePageAction } from '@repo/hooks/usePageAction';
import { useFormActionViewedContext } from '@repo/segment/Analytics/FormActionViewed';
import { INITIAL_DEPOSIT_INPUT_PATTERN } from '../../constants';
import { CurrencyCalculatorInput } from '../../shared/CurrencyCalculatorInput';
import { formatToDisplayValue } from '../../utils/calculatorFormMath';
import { useCdCalculatorStore } from './calculatorStore';

export function InitialDepositForm() {
  // TODO: Segment Standardization Cleanup
  const fireCdCalculatorInteractedPageAction = usePageAction({
    actionName: 'cd_calculator_interacted',
    actionSection: 'banking',
    actionType: 'select',
  });
  const { fireFieldInteracted } = useFormActionViewedContext();
  const {
    annualPercentageYield,
    initialDeposit,
    initialDepositError,
    setField,
    termLength,
    termLengthUnit,
  } = useCdCalculatorStore(
    useShallow(state => ({
      annualPercentageYield: state.formFields.annualPercentageYield,
      initialDeposit: state.formFields.initialDeposit.includes(',')
        ? state.formFields.initialDeposit
        : formatToDisplayValue(state.formFields.initialDeposit),
      initialDepositError: state.errors.initialDeposit,
      termLength: state.formFields.termLength,
      termLengthUnit: state.formFields.termLengthUnit,
      setField: state.setField,
    })),
  );

  return (
    <CurrencyCalculatorInput
      error={initialDepositError}
      id="initial-deposit"
      label="Initial deposit"
      pattern={INITIAL_DEPOSIT_INPUT_PATTERN}
      value={initialDeposit}
      onValidRawChange={raw => {
        fireCdCalculatorInteractedPageAction({
          additional_attributes: {
            annual_percentage_yield_value_input: annualPercentageYield,
            initial_deposit_value_input: raw,
            term_length_value_input: termLength,
            term_length_unit_value_input: termLengthUnit,
          },
        });
        fireFieldInteracted({
          field: 'initial_deposit_value_input',
          fieldType: 'text',
          fieldValue: raw,
          additionalAttributes: {
            annual_percentage_yield_value_input: annualPercentageYield,
            initial_deposit_value_input: raw,
            term_length_value_input: termLength,
            term_length_unit_value_input: termLengthUnit,
            page_type: 'roundup',
          },
        });
        setField('initialDeposit', raw);
      }}
    />
  );
}
